import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';
import {IFamilyData, IFamilyMember} from '@app-types/websocket/family.types';
import {FamilyMemberType} from './family.constants';
import {IChildInfo} from '@app-types/websocket/sharedinfo.types';
import { enrichFamilyData, standardFamilyColors } from './family.utils';
import { enrichFamilySuccess } from './family.actions';

const defaultState: {
    family: IFamilyMember[];
    familyUncolor: IFamilyMember[];
    familyData: IFamilyData;
    childInfo: IChildInfo[];
} = {
  family: [],
  familyUncolor: [],
  familyData: {id: 0,name: 'unknown'},
  childInfo:[]
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

// Server payloads and persisted state can carry null entries or null fields;
// only let well-formed members into the store.
const isValidMember = (member: any): boolean => {
  return !!member && typeof member === "object" && member.id !== undefined;
};

const normalizeMemberList = (members: any): IFamilyMember[] => {
  return Array.isArray(members) ? members.filter(isValidMember) : [];
};

const asMemberArray = (members: any): IFamilyMember[] => {
  return Array.isArray(members) ? members.slice() : [];
};

reducer
  .on(enrichFamilySuccess, (state:any, payload:IFamilyMember[]) => {
    return {
      ...state,
      family: normalizeMemberList(payload),
    };
  })
  .on(commonWebSocket.snapshot.FAMILY_DATA, (state:any, payload:any) => {
    if (!payload?.familyData || typeof payload.familyData !== "object") {
      return state;
    }
    return {
      ...state,
      familyData: payload.familyData
    };
  })
  .on(commonWebSocket.snapshot.FAMILY_SNAPSHOT, (state:any, payload:any) => {
    if (!Array.isArray(payload?.family)) {
      return state;
    }
    return {
      ...state,
      familyUncolor: normalizeMemberList(payload.family),
    };
  })
  .on(commonWebSocket.replace.CHILD_INFO_UPDATE, (state:any, payload:any) => {
    if (!Array.isArray(payload?.childInfo)) {
      return state;
    }

    let childInfo:IChildInfo[] = Array.isArray(state.childInfo) ? state.childInfo.slice() : [];
    const update:IChildInfo[] = payload.childInfo.filter((info: any) => info !== undefined && info !== null);

    if (update.length > 1) {
      childInfo = update;
    } else if (update.length === 1) {
      const newChildInfo = update[0];
      const memberToUpdateIndex:number = childInfo.findIndex((member: IChildInfo) => {
        return member.accountId === newChildInfo.accountId;
      });

      if (memberToUpdateIndex > -1) {
        childInfo[memberToUpdateIndex] = newChildInfo;
      } else {
        childInfo.push(newChildInfo);
      }

    }


    return {
      ...state,
      childInfo
    };
  })
  .on(commonWebSocket.replace.FAMILY_UPDATE, (state: any, payload: {familyUpdate:IFamilyMember}) => {
    if (!isValidMember(payload?.familyUpdate)) {
      return state;
    }

    const family:IFamilyMember[] = asMemberArray(state.family);


    const memberToUpdateIndex = family.findIndex((member: any) => {
      return member.id === payload.familyUpdate.id;
    });

    if (memberToUpdateIndex > -1)
    {
      const color = family[memberToUpdateIndex].color;
      family[memberToUpdateIndex] = payload.familyUpdate;
      family[memberToUpdateIndex].color = color;
    } else {
      const newMem = payload.familyUpdate;
      family.push(newMem);
      enrichFamilyData(family, standardFamilyColors, newMem.id);
    }

    const familyUncolor:IFamilyMember[] = asMemberArray(state.familyUncolor);
    const uncolormemberToUpdateIndex = familyUncolor.findIndex((member: any) => {
      return member.id === payload.familyUpdate.id;
    });

    if (uncolormemberToUpdateIndex > -1)
    {
      const color = familyUncolor[uncolormemberToUpdateIndex].color;
      familyUncolor[uncolormemberToUpdateIndex] = payload.familyUpdate;
      familyUncolor[uncolormemberToUpdateIndex].color = color;
    } else {
      const newMem = payload.familyUpdate;
      familyUncolor.push(newMem);
    }

    return {
      ...state,
      family,
      familyUncolor,
    };

  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/family/family.reducer.ts